import ellaColor from './ella-color.svg';
import ellaMonoBlack from './ella-mono-black.svg';
import ellaMonoWhite from './ella-mono-white.svg';
import facebook from './facebook.svg';
import twitter from './twitter.svg';

export default {
  ellaColor,
  ellaMonoBlack,
  ellaMonoWhite,
  facebook,
  twitter,
};



// WEBPACK FOOTER //
// ./src/img/logos/index.js